module.exports = __webpack_public_path__ + "assets/img/scenePic14.d3891456.png";